import script from "./AddAccount.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddAccount.vue?vue&type=script&setup=true&lang=ts"

import "./AddAccount.vue?vue&type=style&index=0&id=2b5c48e6&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b5c48e6"]])

export default __exports__